import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { ROOT } from "../configs/routeNames";

import Pages from "./Pages";
import { ErrorBoundary } from "../app/molecules/ErrorBoundary";

const Root = () => {
  return (
    <Router>
      <Routes>
        <Route
          path={ROOT}
          element={
            <ErrorBoundary>
              <Pages />
            </ErrorBoundary>
          }
        />
      </Routes>
    </Router>
  );
};

export default Root;
